import { FormattedMessage } from 'react-intl';

import SingleUnitCard from './single-unit-card';

const OutdoorUnits = (props: any) => {
  const { parkingUnitsData } = props;
  return (
    <>
      {parkingUnitsData && parkingUnitsData?.length ? (
        <div className="sv-units-details">
          <div className="row justify-content-between">
            <div className="col-lg-auto col-md-auto col-sm-12">
              <h2 className="units-size-titles">
                <FormattedMessage id="filters.outdoorParking" />
              </h2>
            </div>
          </div>

          <div className="unit-details-table">
            {parkingUnitsData &&
              parkingUnitsData.length &&
              parkingUnitsData.map((item: any, index: any) => {
                return (
                  <SingleUnitCard
                    key={index}
                    showDimensions={true}
                    item={item}
                  />
                );
              })}
          </div>
        </div>
      ) : null}
    </>
  );
};

export default OutdoorUnits;
